// Resized WebP copies of the statically-referenced photos live in
// public/optimized/ (generated by frontend/dev-tools/optimize_images.js).
// They cut download size by 60-90% vs. the original GCS JPEGs.

export const optimizedSrc = (base, width = 1280) => `/optimized/${base}-${width}.webp`;

export const optimizedSrcSet = (base) =>
  [640, 1280, 1920].map((w) => `${optimizedSrc(base, w)} ${w}w`).join(', ');
